let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dYITm")).then(() => parcelRequire('4z95g'));